<template>
  <div class="autumn-course-member-review-video">
    <img class="header-img"
         :src="require('@/pages/2019/AutumnCourse/assets/img/students-comment.png')"
         alt="学员评价视频"
    />
    <ym-video class="ym-video-component"
              :src="src"
              :poster="poster"
    />
    <div class="benefit-info-block">
      <div class="title">2019秋季学期视频直播课（11月）</div>
      <div class="action-status">限时报名中</div>
      <div class="benefit-save">老学员&nbsp;&nbsp;即享930元优惠价</div>
      <div class="hint">*费用包括：课程费、精美主题工具包及学习证书等。</div>
    </div>
    <div class="promise-info">
      <div class="title">我们承诺：</div>
      <div class="change-info">从报课成功到首次课程结束，您将有一次无条件退换课机会；</div>
      <div class="interest">希望每一个孩子都能在少年商学院四大学院中，找到自己真正的兴趣</div>
    </div>
    <div class="join-info-block">
      <span class="text">点击下方，马上为孩子选课</span>
    </div>
  </div>
</template>

<script>
  import YmVideo from '@/components/YmVideo';

  export default {
    name: 'AutumnCourseMemberReviewVideo2019',
    components: {
      YmVideo,
    },
    props: {
      poster: {
        type: String,
        required: true,
      },
      src: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @color-high-light: #ff7508;

  .autumn-course-member-review-video {
    padding: 58px 60px 38px 60px;
    background: @color-white;
  }

  .header-img {
    margin-bottom: 14px;
    display: block;
    width: 312px;
    height: 66px;
  }

  /deep/ .ym-video-component {
    margin: 0 auto 56px;
    width: 630px;
    height: 326px;
  }

  .benefit-info-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-bottom: 16px;
      color: @color-high-light;
      font-size: 30px;
      font-weight: @font-weight-bold;
      text-align: center;
      line-height: 1;
    }
    .action-status {
      margin-bottom: 24px;
      width: 238px;
      height: 50px;
      background: @color-high-light;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      color: @color-white;
      font-weight: @font-weight-bold;
    }

    .benefit-save {
      font-size: @font-size-base;
      font-weight: @font-weight-bold;
      color: @color-high-light;
      line-height: 1;
      &:not(:last-child) {
        margin-bottom: @size-small;
      }
    }

    .benefit-price {
      margin-bottom: 16px;
      font-size: 26px;
      color: @color-text-base;
      .del-text {
        position: relative;
        &:after {
          width: calc(100% - 20px);
          height: 1px;
          background: #ff0000;
          content: '';
          position: absolute;
          left: @size-extra-small;
          top: @size-extra-small;
          transform:rotate(5deg);
        }
      }
    }
    .hint {
      margin-bottom: 52px;
      font-size: @font-size-extra-small;
      color: @color-text-light;
    }
  }
  .promise-info {
    width: 630px;
    margin-bottom: @size-extra-medium;
    padding: @size-base @size-medium;
    box-sizing: border-box;
    background: #feecb9;
    border-radius: 10px;
    font-weight: @font-weight-bold;
    font-size: @font-size-small;
    line-height: 1.6;
    .title {
      margin-bottom: 16px;
      font-size: 26px;
      color: @color-high-light;
      line-height: 1;
    }
    .change-info {
      margin-bottom: 16px;
      color: @color-text-base;
    }
    .interest {
      color: @color-high-light;
    }
  }
  .join-info-block {
    padding-bottom: 55px;
    font-size: 26px;
    font-weight: @font-weight-bold;
    text-align: center;
    line-height: 1;
    color: @color-high-light;
    .text {
      position: relative;
      &:after {
        margin: 0 auto;
        position: absolute;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: @size-base solid @color-high-light;
        content: '';
        bottom: -55px;
        left: 0;
        right: 0;
      }
    }
  }

</style>
